import invariant from 'tiny-invariant';
import validator from 'validator';

import { isNumberish } from '@@utils/string';

// @ts-expect-error TS7006 Issue #4120
const checkIfNaN = (value) => {
    invariant(!isNaN(value), 'No valid numbered Id found');

    return Number(value);
};

// @ts-expect-error TS7006 Issue #4120
// oxlint-disable-next-line eqeqeq
export const compare = (v, t) => v == t;

// @ts-expect-error TS7006 Issue #4120
export const convertToNumber = (value) => {
    if (value == null) {
        return value;
    }

    if (value === 'null') {
        return null;
    }

    if (Array.isArray(value)) {
        return value.map(checkIfNaN);
    }

    return checkIfNaN(value);
};

// @ts-expect-error TS7006 Issue #4120
export const parse = (value) => {
    const isNullOrUndefined = value == null;
    const isEmptyString = value === '';
    const isUuid = typeof value === 'string' && validator.isUUID(value, 'loose');

    if (isNullOrUndefined || isEmptyString || isUuid) {
        return value;
    } else if (isNumberish(value)) {
        return Number(value);
    }

    throw new Error(`Could not parse id "${value}" of type "${typeof value}"!`);
};
